const literals = {
  boulierCells: 'boulier__number',
  numberCells: 'cell__number',
  numberPrefix: 'number-',
};

export default literals;
